module.exports = __webpack_public_path__ + "media/application/images/svgs/circle-c5fd0d36a8d7da42610dc5c0e421dcff.svg";